import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  NavController,
  NavParams,
  PopoverController,
  LoadingController,
} from "ionic-angular";
import { Subscription } from "rxjs";

import { AuthProvider } from "../../providers/auth/auth";
import { JobsProvider } from "../../providers/jobs/jobs";
import { TrainingCardsProvider } from "../../providers/training/training";
import { DistrictsProvider } from "../../providers/districts/districts";

import { JobInfoComponent } from "./../../shared/jobs/job-info";
import { TrainingCardInfoComponent } from "./../../shared/training/training-card-info";

import { IJob, IJobStaff } from "./../../interfaces/jobs";
import {
  ITrainingCard,
  ITrainingCardStaff,
  TrainingCardStatus,
  TrainingCardApplicationStatus,
} from "./../../interfaces/training-cards";

@Component({
  selector: "page-my-jobs",
  templateUrl: "my-jobs.html",
})
export class MyJobsPage implements OnInit, OnDestroy {
  title = "My Diary";
  fbUser: any;
  currentUser: any;
  currentUserSubscription: Subscription;
  userDataLoaded = false;

  userJobApplications: Array<IJobStaff> = [];
  userJobs: Array<IJob> = [];
  userJobsDataLoaded = false;
  userJobsSubscription: Subscription;

  userTrainingCardApplications: Array<ITrainingCardStaff> = [];
  userTrainingCards: Array<ITrainingCard> = [];
  userTrainingCardsDataLoaded = false;
  userTrainingCardsSubscription: Subscription;

  jobDetailsSubsciption: Subscription;
  trainingCardDetailSubscription: Subscription;

  get trainingCardStatus() {
    return TrainingCardStatus;
  }

  get trainingCardApplicationStatus() {
    return TrainingCardApplicationStatus;
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    public loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private jobsProvider: JobsProvider,
    private districtsProvider: DistrictsProvider,
    private trainingCardProvider: TrainingCardsProvider
  ) {}

  ngOnInit() {
    let loader = this.loadingCtrl.create({
      content: "Loading your jobs...",
    });
    loader.present();

    this.authProvider.getFbUser().then((fbUser) => {
      console.log(fbUser);
      this.currentUserSubscription = this.authProvider
        .getUserByUid(fbUser.uid)
        .subscribe(
          (data) => {
            console.log(data);
            this.currentUser = data;

            if (this.currentUser.regType === "recruiter") {
              // TODO: Load recruiter items in dashboard
            } else {
              this.loadUserJobs();
              this.loadUserTrainingCards();
            }

            loader.dismiss();
            this.userDataLoaded = true;
            return data;
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  loadUserJobs() {
    this.userJobsSubscription = this.jobsProvider
      .getUserJobs(this.currentUser.uid)
      .subscribe(
        (result) => {
          this.userJobs = [];
          this.userJobApplications = [];
          console.log("--- User Jobs ---");
          console.log(result);

          this.userJobApplications = result;
          result.forEach((userJob) => {
            this.jobDetailsSubsciption = this.jobsProvider
              .getJobDetails(userJob.jobId)
              .subscribe(
                (result) => {

                  console.log(result);
                  // TODO: Need to make another plan here. When data is updated it is just adding to my jobs list... not ideal
                  this.userJobs.push(result);
                  return result;
                },
                (err) => {
                  console.log(err);
                }
              );
          });
          console.log(this.userJobs);
          this.userJobsDataLoaded = true;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  loadUserTrainingCards() {
    this.userTrainingCardsSubscription = this.trainingCardProvider
      .getUserTrainingCards(this.currentUser.uid)
      .subscribe(
        (result) => {
          this.userTrainingCards = [];
          this.userTrainingCardApplications = [];
          console.log("--- User Training Cards ---");
          console.log(result);

          this.userTrainingCardApplications = result;
          this.userTrainingCardApplications.forEach((userTrainingCard) => {
            this.trainingCardDetailSubscription = this.trainingCardProvider
              .getTrainingCardDetails(userTrainingCard.trainingCardId)
              .subscribe(
                async (result) => {
                  console.log(result);
                  result.userHasApplied = true;
                  result.userApplicationStatus = userTrainingCard.status;
                  result.userDistrict = await this.districtsProvider
                    .getDistrictPromise(userTrainingCard.district)
                    .then((district) => {
                      return district;
                    });
                  // TODO: Need to make another plan here. When data is updated it is just adding to my jobs list... not ideal
                  this.userTrainingCards.push(result);
                  return result;
                },
                (err) => {
                  console.log(err);
                }
              );
          });
          this.userTrainingCardsDataLoaded = true;
          return result;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getUserApplicationStatus(jobId: string): number {
    return this.userJobApplications.find((j) => j.jobId === jobId).status;
  }

  ngOnDestroy() {
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
    if (this.userJobsSubscription) {
      this.userJobsSubscription.unsubscribe();
    }
    if (this.jobDetailsSubsciption) {
      this.jobDetailsSubsciption.unsubscribe();
    }
  }

  openJob(job: IJob) {
    console.log(job);
    let popover = this.popoverCtrl.create(
      JobInfoComponent,
      { job: job, user: this.currentUser },
      {
        showBackdrop: true,
        enableBackdropDismiss: false,
        cssClass: "job-popover",
      }
    );
    popover.present({
      ev: job,
    });
  }

  openTrainingCard(trainingCard: ITrainingCard) {
    console.log(trainingCard);

    let popover = this.popoverCtrl.create(
      TrainingCardInfoComponent,
      { trainingCard: trainingCard, user: this.currentUser },
      {
        showBackdrop: true,
        enableBackdropDismiss: false,
        cssClass: "training-card-popover",
      }
    );
    popover.present({
      ev: trainingCard,
    });
  }

  ionViewWillLeave() {
    console.log("inside ionViewWillLeave - MyJobs");
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
    if (this.userJobsSubscription) {
      this.userJobsSubscription.unsubscribe();
    }
    if (this.jobDetailsSubsciption) {
      this.jobDetailsSubsciption.unsubscribe();
    }
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad MyJobsPage");
  }
}



// WEBPACK FOOTER //
// ./src/pages/my-jobs/my-jobs.ts